import React from 'react'
import * as E from './footerElements'

interface IInputProps {
  classes: string
  text: string
  linkUrl: string
  ariaLabel?: string
}

const OlyLink = ({
  classes,
  text,
  linkUrl,
  ariaLabel,
}: IInputProps) => {
  
  return (
    <E.FooterLinks
      className={classes ? classes : ''}
      href={linkUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      {text}
    </E.FooterLinks>
  )
}

export default OlyLink
